import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import OurPromise from "./sections/OurPromise";
import MeetTheCaregivers from "./sections/MeetTheCaregivers";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Header />
      <OurStory />
      <OurPromise />
      <MeetTheCaregivers />
      <Footer />
    </div>;
}